export default "__VITE_ASSET__hAh9xJ57__"